module.exports = __webpack_public_path__ + "static/media/master-card.ae677f86.png";